import { Component, Input } from '@angular/core';
import { getProfielnaam } from '../../../profiel/model/profiel-in-team';
import {
  ParkourButtonComponent,
  ParkourIconComponent,
  ParkourPopupService,
  ParkourToastService,
} from '@parkour/ui';
import { TeamService } from '../../service/team.service';
import { ContextService } from '../../../shared/services/context.service';
import { ProfielId } from 'parkour-web-app-dto';
import { JongereProfiel } from '../../../profiel/model/profiel';

@Component({
  standalone: true,
  selector: 'parkour-team-verlaten-section',
  templateUrl: './team-verlaten-section.component.html',
  imports: [ParkourButtonComponent, ParkourIconComponent],
})
export class TeamVerlatenSectionComponent {
  @Input({ required: true }) jongere!: JongereProfiel;
  @Input({ required: true }) teamlidProfielId!: ProfielId;

  constructor(
    private readonly parkourPopupService: ParkourPopupService,
    private readonly parkourToastService: ParkourToastService,
    private readonly teamService: TeamService,
    private readonly contextService: ContextService,
  ) {}

  openTeamVerlatenModal() {
    this.parkourPopupService
      .showPopup({
        title: 'Team verlaten',
        description:
          'Ben je zeker dat je het team wil verlaten? Als je het team verlaat, kun je er niet opnieuw lid van worden zonder de uitnodiging van de teameigenaar. Je verliest ook de toegang tot alle teamgegevens.',
        icon: 'login',
      })
      .then((result) => {
        if (result === 'yes') {
          this.verlaatTeam();
        }
      });
  }

  private verlaatTeam() {
    this.teamService
      .removeTeamlid(this.jongere.id, this.teamlidProfielId, 'verlaten')
      .subscribe(() => {
        this.parkourToastService.showToast({
          header: `Team verlaten`,
          content: `Je verliet het team. \n Je bent niet langer teamlid van ${getProfielnaam(
            this.jongere,
          )}.`,
        });

        this.contextService.switchContext(this.teamlidProfielId, 'voor-mezelf', ['profiel']);
      });
  }
}
